export function shouldAutomaticallyConfirmNarrativeTurn(
    enabled: boolean | undefined
): boolean {
    return enabled !== false
}
